import { render, staticRenderFns } from "./accountUnfreezing.vue?vue&type=template&id=7bde22dd&scoped=true&"
import script from "./accountUnfreezing.vue?vue&type=script&lang=js&"
export * from "./accountUnfreezing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bde22dd",
  null
  
)

component.options.__file = "accountUnfreezing.vue"
export default component.exports